import createReactComponent from '../createReactComponent';
export default createReactComponent('anchor', 'Anchor', [["path",{"d":"M5 12H3a9 9 0 1 0 18 0h-2m-7-5v14m0-14a2 2 0 1 0 0-4 2 2 0 0 0 0 4","key":"svg-0"}]]);